/** Clickable hashtag: # plus a letter, then at least one more letter, number, or underscore. */
const HASHTAG_TOKEN = "#[A-Za-z][A-Za-z0-9_]{1,63}";

export function hashtagHref(raw: string): string {
  const tag = raw.replace(/^#/, "").toLowerCase();
  return `/hashtag/${encodeURIComponent(tag)}`;
}

/**
 * Turn #hashtag tokens into links to `/hashtag/<tag>`.
 * Skips text already inside a link, code, or pre tag.
 */
export function linkifyHashtagHtml(html: string): string {
  if (!html || !html.includes("#")) return html;
  const parts = html.split(/(<[^>]+>)/g);
  let skip = 0;
  return parts
    .map((part) => {
      if (part.startsWith("<")) {
        const lower = part.toLowerCase();
        if (/^<(a|code|pre)(\s|>|\/)/.test(lower)) skip += 1;
        else if (/^<\/(a|code|pre)>/.test(lower)) skip = Math.max(0, skip - 1);
        return part;
      }
      if (skip > 0 || !part.includes("#")) return part;
      return part.replace(
        new RegExp(`(^|[^A-Za-z0-9_])(${HASHTAG_TOKEN})`, "g"),
        (_full, prefix: string, token: string) => {
          return `${prefix}<a href="${hashtagHref(token)}" class="text-blue-600 hover:underline font-medium">${token}</a>`;
        },
      );
    })
    .join("");
}

export const RICH_TEXT_SPLIT = new RegExp(`(@[a-zA-Z0-9_-]+|${HASHTAG_TOKEN})`);
export const HASHTAG_ONLY = new RegExp(`^${HASHTAG_TOKEN}$`);
